<label class="p-a p-a-3-m p-a-3-s block cursor-pointer">
    <div class="flex flex-top ">
        <input type="radio"
               [value]="value"
               [(ngModel)]="model"
               [required]="required"
               [disabled]="disabled"
               (ngModelChange)="onModelChange()"
               [name]="name || ''">


        <div class="_content flex-grow">
            <!-- Use either radioBody to have own stylijng or regular content to have default one -->
            <div class="flex flex-top flex-grow">
                <p class="s1 flex-grow">
                    <ng-content select="[radioTitle]"></ng-content>
                </p>
                <p class="s2 col-1 hideEmpty">
                    <ng-content select="[radioAside]"></ng-content>
                </p>
            </div>
            <p class="p2 col-11 m-t-1 hideEmpty">
                <ng-content select="[radioSubtitle]"></ng-content>
            </p>
        </div>
    </div>
    <div class="p2 col-12">
        <ng-content select="[radioBottom]"></ng-content>
    </div>
</label>
